<i class="ficon-paperclip"></i>
@if (showBadge && attachmentsCount > 0) {
  <span
    class="badge"
    >
    {{attachmentsCount}}
  </span>
}
<ng-content></ng-content>
